import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface employee {
    id?: number;
    name?: string;
    salary?: number;
    additional_time?: number;
    additional_value?: number;
    absence_time?: number;
    discount_value?: number;
    net_salary?: number;
}

// Salaries state
export interface salariesState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isSuccess: boolean,
    isOpen: boolean,
    employees: employee[]
}

const initialSalariesState: salariesState = {
    isLoaded: false,
    isLoading: false,
    isSuccess: false,
    isOpen: false,
    employees: []
}

// Salaries slice
export const salariesSlice = createSlice({
    name: 'salaries',
    initialState: initialSalariesState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
        close: ( state ) => {
            state.isOpen = false
            state.isLoading = false
            state.isSuccess = false
        },
        addEmployees: ( state, {payload}: PayloadAction<employee[]> ) => {
            state.employees = [ ...state.employees, ...payload ]
        },
        updateEmployee: ( state, {payload}: PayloadAction<{ index: number, employee: employee }> ) => {
            state.employees[payload.index] = { ...state.employees[payload.index], ...payload.employee }
        },
        updateDefaultSalaries: ( state, {payload}: PayloadAction<employee[]> ) => {
            payload.map(employee => {
                let index = state.employees.findIndex(item => item.id == employee.id)
                if( index != -1 )
                state.employees[index] = { ...state.employees[index], ...employee }
            })
            state.isLoaded = true
        },
    }
})